document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Cart Drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (cartDrawer) { cartDrawer.setAttribute('data-open', ''); cartDrawer.setAttribute('aria-hidden', 'false'); }
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (cartDrawer) { cartDrawer.removeAttribute('data-open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
    });
  });

  /* ---------- Search Modal ---------- */
  var searchModal = document.querySelector('[data-search-modal]');
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal) {
        searchModal.setAttribute('data-open', '');
        searchModal.setAttribute('aria-hidden', 'false');
        var input = searchModal.querySelector('[data-search-input]');
        if (input) input.focus();
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal) { searchModal.removeAttribute('data-open'); searchModal.setAttribute('aria-hidden', 'true'); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (cartDrawer) { cartDrawer.removeAttribute('data-open'); }
      if (searchModal) { searchModal.removeAttribute('data-open'); }
    }
  });

  /* ---------- Quantity stepper (product page) ---------- */
  document.querySelectorAll('.tvd-quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('[data-qty-input]');
    var decrease = stepper.querySelector('[data-qty-decrease]');
    var increase = stepper.querySelector('[data-qty-increase]');
    if (!input) return;
    if (decrease) decrease.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (increase) increase.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Sticky product buy bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var productInfo = document.querySelector('.tvd-product__info');
  if (stickyBar && productInfo) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(productInfo);
  }

});
